export const formatProjectType = (type: string): string => {
  const typeMap: Record<string, string> = {
    'fixed_price': 'Fixed Price',
    'time_materials': 'Time and Materials'
  };
  return typeMap[type] || type;
};